import { AbstractAccessorService } from "@core/data-access";
import type { IDataAccessor } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { ICountryRestService } from './country-rest'

export class CountryRestService extends AbstractAccessorService<qpmn.common.rest.IRestService> implements ICountryRestService {
    public readonly $name: string = "CountryRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<qpmn.common.rest.IRestService>) {
        super();
    }

    /**
     * @description 获取国家列表
     */
    public getCountryList(page: number, limit: number, filter?: string, sort?: string): angular.IPromise<IResponse<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.ICountryContent>>> {
        return this.$accessor<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.ICountryContent>, { page: number, limit: number, filter?: string, sort?: string }, string>(this.$name, "getCountryList", {
            parameter: {
                page: page,
                limit: limit,
                filter: filter,
                sort: sort ? sort : encodeURI(JSON.stringify([{ "property": "name", "direction": "ASC" }]))
            }
        });
    }
    /**
     * @description 获取区域列表
     */
    public getZoneByCountryId(countryId: number): angular.IPromise<IResponse<Array<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.IZoneContent>>>> {
        return this.$accessor<Array<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.IZoneContent>>, { countryId: number }, string>(this.$name, "getZoneByCountryId", {
            parameter: {
                countryId: countryId
            }
        });
    }
    /**
     * @description 获取可用国家列表
     * @param page
     * @param limit
     * @param filter
     * @param sort
     */
    public getUsableCountries(page: number, limit: number, filter?: string, sort?: string): angular.IPromise<IResponse<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.ICountryContent>>> {
        return this.$accessor<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.ICountryContent>, { page: number, limit: number, filter?: string, sort?: string }, string>(this.$name, "getUsableCountries", {
            parameter: {
                page: page,
                limit: limit,
                filter: filter,
                sort: sort ? sort : encodeURI(JSON.stringify([{ "property": "name", "direction": "ASC" }]))
            }
        });
    }
}